import {formatDuration} from 'external/date-fns'
import {useRef, useEffect} from 'external/react'
import {
  clsx,
  Fade,
  Box,
  TableContainer,
  TableBody,
  TableRow,
  TableCell,
  Table,
  Chip
} from 'external/material'

import {assessmentsRowHeight} from 'settings'

import AssessmentsHead from './AssessmentsHead'
import Action from './Action'
import Pagination from 'components/Table/Pagination'

import useDynamicPageSize from 'hooks/dynamic-page-size'
import useAssessment from 'hooks/assessment'
import useTranslations from 'hooks/translations'
import useSession from 'hooks/session'


export default function Assessments() {

  const {groupId} = useSession()

  const {formatDate, language, translate} = useTranslations()
  const {assessments, getType} = useAssessment()

  return (
    <Box className="assessments">
      <TableContainer className="assessmentsTableContainer">
        <Table stickyHeader className="assessmentsTable">
          <AssessmentsHead actionsLabel="status" />
            <TableBody>
              {assessments.map((assessment, i) => {
                const {assessmentProperties: properties} = assessment
                return (<TableRow key={i}>
                  <TableCell className="titleCell" align="left">
                    <span className={clsx("title")}>{properties.title}</span>
                  </TableCell>
                  <TableCell align="left"><span className={"start"}>{formatDate(assessment.start)}</span></TableCell>
                  <TableCell align="left"><span className={"finish"}>{formatDate(assessment.finish)}</span></TableCell>
                  <TableCell align="left"><span className={"type"}>{translate(getType(properties.type))}</span></TableCell>
                  <TableCell align="left"><span className={"duration"}>{formatDuration(assessment.duration, language)}</span></TableCell>
                  <TableCell align="center">
                    <span className={"actions"}>
                      {groupId && <Action assessment={assessment} />}
                    </span>
                  </TableCell>          
                </TableRow>)
              })}
            </TableBody>
        </Table>
      </TableContainer>
    </Box>
  )
}
